import { render, staticRenderFns } from "./captureTrace.vue?vue&type=template&id=72241fb9&scoped=true"
import script from "./captureTrace.vue?vue&type=script&lang=js"
export * from "./captureTrace.vue?vue&type=script&lang=js"
import style0 from "./captureTrace.vue?vue&type=style&index=0&id=72241fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72241fb9",
  null
  
)

export default component.exports